import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { Checkbox, TextInput } from '@dbk/ui-forms';
import Button from '@dbk/ui-buttons';
import { List, ListItem } from '@dbk/ui-list';
import Spinner from '@dbk/ui-spinner';
import { ROUTES, DOC_UPLOAD } from '../../../../constants';
import DocUploadContractList from '../common/doc-upload-contract-list';
import BlurModal from '../../../../components/common/blur-modal';
import { NotificationWarning } from '@dbk/ui-icons';

class UploadDocument extends PureComponent {
  constructor(props) {
    super(props);
  }

  state = {
    bpsearch: '',
    isCheckboxSelected: '',
    isTableVisible: false,
    selectedOptions: [],
    bpList: '',
  }

  componentWillMount(){
    const { docupload: { setUploadFormData } } = this.props;
    setUploadFormData(null);
  }

  componentDidUpdate(prevProps){
    if(prevProps.docupload.contractDetails !== this.props.docupload.contractDetails){
      this.isContractData();
    }
  }

  continueClicked = () => {
    const finalSelectedContracts = this.state.selectedOptions.filter(el => el.isChecked === true );
    this.props.docupload.setSelectedContractDetails(finalSelectedContracts);
    this.props.docupload.setDocUploadWizardIndex(1);
    // this.props.changePage(ROUTES.RMACCESS.DOC_FORM);
  }

  searchClicked() {
    const { docupload: { fetchContractsForBp } } = this.props;
    if (this.state.bpsearch) {
      this.setState({
        isTableVisible: true
      })
     
      fetchContractsForBp(this.state.bpsearch);
    }
  }

  onEnterSearchBp(e){
    const { docupload: { fetchContractsForBp } } = this.props;
    if(e.key === "Enter"){
      fetchContractsForBp(this.state.bpsearch);
    }
  }

  isContractData(){
    const newOptions = this.props.docupload.contractDetails.map((item) => {
      item.isChecked = false;
      item.adminEmailId = this.props.rmAccess.adminEmailId
      return item;
    })
    this.setState({
      selectedOptions: newOptions
    });
  }

  selectAllContractClick(e) {
    const tempOptions = this.state.selectedOptions.map((item) => {
      if(item.status !== DOC_UPLOAD.NON_DWO_USER && item.authority !== null){
        e.target.checked ? item.isChecked = true : item.isChecked = false;
      }else{
        item.isChecked = false;
      }
      return item;
    })
    this.setState({
      selectedOptions: tempOptions,
      isCheckboxSelected: !this.state.isCheckboxSelected,
    })
    
  }

  contractItemClick(e, options) {
     const newSelOptions = this.state.selectedOptions.map((item) => {
       if(options.contract === item.contract && item.status !== DOC_UPLOAD.NON_DWO_USER){ 
           item.isChecked = !item.isChecked;
        }else if(item.status === DOC_UPLOAD.NON_DWO_USER){
          item.isChecked = false;
        }
        return item;
     })
     this.setState({
      selectedOptions: newSelOptions,
      isContinueBtnEnabled: !this.state.isContinueBtnEnabled
    });

    const newArray = this.state.selectedOptions.filter( el => el.isChecked === false);

    newArray.length >= 1 ? this.setState({
            isCheckboxSelected: false
          }) : this.setState({
            isCheckboxSelected: true,
          }) 
  }

  onReset() {
    this.setState({
      bpsearch: ''
    })
  }

  onBack() {
    this.props.changePage(ROUTES.RMACCESS.DOC_LANDING_PAGE);
  } 

  closeBlurModel = () => {
    this.props.docupload.setBlurModalError(false);
  }

  renderErrorModal = () => {
    const { docupload: { showErrorModal, errorTitle, errorMsg } } = this.props;

    return (
        <BlurModal
            visible={showErrorModal}
            doneVisible={false}
            title={<h4>{errorTitle}</h4>}
            onDone={() => this.closeBlurModel()}
        >
            <div className="error-message-container">
                <NotificationWarning color='#b92635' className="error-icon" width={25} height={25} />
                <span className="error-message-content">{errorMsg}</span>
            </div>
        </BlurModal>
    )
  }

  render() {
    const { i18n: { messages }, docupload: { search: { showSpinner }, showErrorModal } } = this.props;
    const isContinueBtn = this.state.selectedOptions.filter(el => el.isChecked === true );
      
    return (
      <div>

        <div>
          <div className="columns large-12 large-centered searchBox">
            <div>
              <div className="columns large-6 large-centered serach-text-font">{messages['app.documentUpload.radio.BusinessPartner']}</div>
              <div className="columns large-6 large-centered medium-12 small-12 padding20">
                <TextInput
                  className="columns small-12 medium-12 large-12 large-centered"
                  style={{ marginBottom: '10px;' }}
                  textID="textInput_bp_search_id_test"
                  accessibilityLabel="textInput_bp_search_id_test"
                  name="bpsearch"
                  size="large"
                  value={this.state.bpsearch}
                  placeholder={"for e.g. BP 1001001"}
                  type="text"
                  autoCorrect={false}
                  selectTextOnFocus={false}
                  onKeyPress={(e) => this.onEnterSearchBp(e)}
                  onChange={event => { this.setState({ bpsearch: event.target.value }) }}
                />
              </div>
              <div className="columns large-12 medium-12 small-12 doc-upload-search-btns">
                <Button
                  size='large'
                  textID="btn_uploadDoc_reset_test"
                  accessibilityLabel="btn_uploadDoc_reset_test"
                  onPress={() => this.onReset()} tertiary>
                  {messages['app.documentUpload.button.reset']}
                </Button>
                <Button
                  size='large'
                  textID="btn_uploadDoc_search_test"
                  accessibilityLabel="btn_uploadDoc_search_test"
                  disabled={!this.state.bpsearch}
                  onPress={() => this.searchClicked()} >
                  {messages['app.documentUpload.button.search']}
                </Button>
              </div>
            </div>
            {showSpinner && <div className="columns large-2 large-centered">
              <Spinner testID="spinner_contractList_loading_test"
                accessibilityLabel="spinner_contractList_loading_test" /></div>}
            {this.state.selectedOptions.length > 0 &&
              <div>
                <div className="columns large-12">
                  <span className="serach-text-font">{messages['app.documentUpload.contractList']}</span>
                  <span className="columns large-2 small-4 small-offset-4 large-offset-3">
                    <Checkbox checked={this.state.isCheckboxSelected} textID="chkBx_uploadDoc_selectAll_test"
                      accessibilityLabel="chkBx_uploadDoc_selectAll_test"
                      onChange={(e) => this.selectAllContractClick(e)}
                    />
                    <span style={{ marginLeft: '10px' }}>{messages['app.chedelivery.reports.selectAll']}</span>
                  </span>
                </div>
                <DocUploadContractList 
                  contractListData={ this.state.selectedOptions }
                  onItemClick= {(e, option) => this.contractItemClick(e, option)}
                  disabled={false}
                  />

                <div className="columns large-12
                                      small-12 medium-12
                                      doc-upload-search-table-btns">
                  <Button
                    size='large'
                    textID="btn_uploadDoc_cancel_test"
                    accessibilityLabel="btn_uploadDoc_cancel_test"
                    onPress={() => this.onBack()} tertiary>
                    {messages['app.documentUpload.button.back']}
                  </Button>
                  <Button
                    size='large'
                    textID="btn_uploadDoc_search_continue_test"
                    accessibilityLabel="btn_uploadDoc_search_continue_test"
                    disabled={isContinueBtn.length === 0}
                    onPress={() => this.continueClicked()} >
                    {messages['app.documentUpload.button.continue']}
                  </Button>
                </div>
                {/* <div className="doc-upload-info-msg">{messages['app.documentUpload.searchpage.info.msg']}</div> */}
              </div>
            }
          </div>
          {showErrorModal && this.renderErrorModal()}
        </div>
      </div>

    )
  }

}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    changePage: { $call: 'ui.history.push' },
    docupload: {
      fetchContractsForBp: { $call: 'fetchContractsForBp' },
      contractDetails: true,
      search: { showSpinner: true },
      setDocUploadWizardIndex: { $set: 'docUploadWizardIndex' },
      setSelectedContractDetails: { $set: 'selectedContractDetails' },
      docTypes: true,
      acceptances: true,
      statuses: true,
      errorMsg: true,
      showErrorModal: true,
      errorTitle: true,
      setBlurModalError: { $set: 'showErrorModal'},
      setUploadFormData: { $set: 'uploadFormData'},
    },
    rmAccess:{
      adminEmailId: true
    }
  },
})(UploadDocument);
